import { message } from "antd";
import { API_CENTER } from "../../services/api/api";
import {
  DocumentToSign,
  DocumentType,
  DocumentKkb,
} from "../../store/slice/requestAppSlise/requestAppSlise";
/*

************** Тип Утилита функия {Скачивание Файлов}
v.1
@param url Статичный линка для обращения на бэк
@param urlId если ссылка ожидает id или любой другой маркер разширение статичной ссылки
@param fileName дать название скачинному файлу как статично так и динамично может работать
@param fileType ожидает тип файла pdf sig zip и тд

************** Рекомендация по написанию вызова **************************
************** const paraUrlS = {
**************    url: `client/RequestFile/?filepath=${path}/?document_id=${document_id}`,
**************    fileName: fileName,
**************  };
**************  const downloadingFiles = () => DownloadingFiles(paraUrlS);

v.2
@param url  должен содержать так же и ид файла если нужно
@param fileName дать название скачинному файлу как статично так и динамично может работать

если получит тип файла "application/json" вернет ошибку в консоль
************** Рекомендация по написанию вызова **************************
************** const configUrlDonwnLoad = {
**************    url: `client/RequestFile/?filepath=${path}/?document_id=${document_id}`,
**************    fileName: fileName,
**************  };
**************  const downloadingFiles = () => DownloadingFiles(paraUrlS);

v3
 function getExtension(file_name: string) {
    if (typeof file_name === "string") {
      // file_name.split(".")[file_name.split(".").length - 1];
      return file_name.split(".").reverse()[0];
    }
  }
  сделать проверку на тип файла и возврата 
*/
export type TypeUrlParam = {
  url: string;
  fileName: string;
};

const convertBlobMessage = async (res: Blob) => {
  const blob = new Blob([res], { type: "application/json" });
  const text = await blob.text();
  const json = JSON.parse(text);
  return json.message;
};

export async function DownloadingFiles(props: TypeUrlParam) {
  const { url, fileName } = props;
  const ApiStart = new API_CENTER();

  try {
    const res = await ApiStart.configAxios(
      `${url}`,
      {
        responseType: "blob",
      },
      true,
    );

    if (res.type !== "application/json") {
      const blob = new Blob([res], { type: res.type });
      const url_1 = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url_1;
      anchor.download = `${fileName}`;
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
    } else {
      const errorMessage = await convertBlobMessage(res);
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorObject =
      typeof error === "string"
        ? { message: error }
        : (error as { message: string });

    message.error(errorObject.message);
  }
}

export const onClickDownloadApplicationFile = async (
  doc: DocumentToSign,
  applicationBankId: number,
) => {
  if (doc.type_doc.type === "ANKETA") {
    DownloadingFiles({
      url: `/auth/sign/client-anketa/${applicationBankId}/show`,
      fileName: `Анкета`,
    });
    return;
  }

  if (doc && doc.application_banks_id) {
    DownloadingFiles({
      url: `auth/applications/system-bank/create-data-to-bank/${doc.application_banks_id}/file/${doc.id}`,
      fileName: `${doc.name}`,
    });
    return;
  }
};
export const onClickDownloadApplicationFileFromBank = async (
  doc: DocumentType<DocumentKkb>,
  applicationBankId: number,
) => {
  if (doc.type === "ANKETA") {
    DownloadingFiles({
      url: `/auth/sign/client-anketa/${applicationBankId}/show`,
      fileName: `Анкета`,
    });
    return;
  }
  if (doc.document && doc.document.application_banks_id) {
    DownloadingFiles({
      url: `auth/applications/system-bank/create-data-to-bank/${doc.document.application_banks_id}/file/${doc.id}`,
      fileName: `${doc.name}`,
    });
    return;
  }
};
